export const formatGmailInternalDate = (internalDate: string): string => {
  const ms = Number(internalDate);
  if (!Number.isFinite(ms)) return "—";
  return new Date(ms).toLocaleString();
};

export const isGmailMessageUnread = (labelIds: string[]): boolean =>
  labelIds.includes("UNREAD");
